import React, { FC } from 'react';
import styles from './entity_page.module.scss';

export const EntityPage: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
